import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";
const initialState = {
  value: {
    pageName:"",
    menu: [],
    menu_by_user: [],
    arrayMenu: "",
    arraySubmenu: "",
    permission_by_user: [],
    arrayPermission: "",
  },
};

export const utilsSlice = createSlice({
  name: "utility",
  initialState,
  reducers: {
    setPageName:(s,a)=>{
      s.value.pageName = a.payload.pageName
    },
    setAllMenu: (s, a) => {
      let userMenu = [];
      userMenu = a.payload.userMenu;

      let aMenu = [];
      let bMenu = [];
      aMenu = a.payload.menu;

      for (let i of userMenu) {
        let menuidx = aMenu.findIndex((a) => a.id === i.id);

        if (menuidx !== -1) {
          aMenu[menuidx].grant = true;
        }

        if (aMenu[menuidx].submenu) {
          for (let j of aMenu[menuidx].submenu) {
            let submenuidx = aMenu[menuidx].submenu.findIndex(
              (b) => b.id === j.id
            );

            if (submenuidx !== -1) {
              aMenu[menuidx].submenu[submenuidx].grant = true;
            }
          }
        }
      }

      s.value.menu = aMenu;
    },
    setMenuByUser: (s, a) => {
      s.value.arrayMenu = "";
      s.value.arraySubmenu = "";
      s.value.menu_by_user = a.payload.menu;
      let menu = a.payload.menu;
      for (let i of menu) {
        if (i.grant) {
          if (s.value.arrayMenu.length > 0) s.value.arrayMenu += ",";
          s.value.arrayMenu += i.id;

          for (let j of i.submenu) {
            if (j.grant) {
              if (s.value.arraySubmenu.length > 0) s.value.arraySubmenu += ",";
              s.value.arraySubmenu += j.id;
            }
          }
        }
      }
    },
    updateMenuByUser: (s, a) => {
      if (a.payload.type == "menu") {
        let idx = s.value.menu_by_user.findIndex(
          (i) => i.id == a.payload.idChecked
        );
        if (a.payload.isChecked) {
          if (idx !== -1) {
            s.value.menu_by_user[idx].grant = false;
            s.value.menu_by_user[idx].submenu.map((i) => (i.grant = false));
          }
        } else {
          if (idx !== -1) {
            s.value.menu_by_user[idx].grant = true;
            s.value.menu_by_user[idx].submenu.map((i) => (i.grant = true));
          }
        }
      } else {
        for (let i of s.value.menu_by_user) {
          let idx = i.submenu ? i.submenu.findIndex((i) => i.id == a.payload.idChecked) : -1;
          if (a.payload.isChecked) {
            if (idx !== -1) {
              i.submenu[idx].grant = false;
            }
          } else {
            if (idx !== -1) {
              i.submenu[idx].grant = true;
            }
          }
        }
      }

      s.value.arrayMenu = "";
      s.value.arraySubmenu = "";
      let menu = s.value.menu_by_user;
      for (let i of menu) {
        if (i.grant) {
          if (s.value.arrayMenu.length > 0) s.value.arrayMenu += ",";
          s.value.arrayMenu += i.id;

          for (let j of i.submenu) {
            if (j.grant) {
              if (s.value.arraySubmenu.length > 0) s.value.arraySubmenu += ",";
              s.value.arraySubmenu += j.id;
            }
          }
        }
      }
    },
    setPermissionByUser: (s, a) => {
        s.value.arrayPermission = "";
        s.value.permission_by_user = a.payload.permission;
        let permission = a.payload.permission;
        for (let i of permission) {
          if (i.grant) {
            if (s.value.arrayPermission.length > 0) s.value.arrayPermission += ",";
            s.value.arrayPermission += i.id;
          }
        }
      },
    updateMenuPermissionByUser: (s, a) => {
        let idx = s.value.permission_by_user.findIndex(
          (i) => i.id == a.payload.idChecked
        );
        if (a.payload.isChecked) {
          if (idx !== -1) {
            s.value.permission_by_user[idx].grant = true;
          }
        } else {
          if (idx !== -1) {
            s.value.permission_by_user[idx].grant = false;
          }
        }
  
        s.value.arrayPermission = "";
        let permission = s.value.permission_by_user;
        for (let i of permission) {
          if (i.grant) {
            if (s.value.arrayPermission.length > 0) s.value.arrayPermission += ",";
            s.value.arrayPermission += i.id;
          }
        }
      },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, (s) => {
      s.value = initialState.value;
    });
  },
});

export const { setAllMenu, setMenuByUser, updateMenuByUser,updateMenuPermissionByUser,setPermissionByUser,setPageName } =
  utilsSlice.actions;
export default utilsSlice.reducer;
